<template>
    <div class="de-header-title-wrapper" :style="fontStyle">
        <div class="header-title1" v-if="type.value==1" :style="titleStyle">{{title}}</div>
        <div class="header-title2" v-if="type.value==2" :style="titleStyle">{{title}}</div>
        <div class="header-title3" v-if="type.value==3">
            <div class="layout-header-content">
                <div class="header-title" :style="titleStyle">
                    <i class="arrow arrow-left"></i>
                    {{title}}
                    <i class="arrow arrow-right"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'de-header-title',
    props: {
        type: {
            type: Object,
            default: () => {
                return {
					label: '标题1',
					value: 1
				}
            }
        },
        title: {
            type: [String, Number],
            default: '标题'
        },
        fontObj: {
            type: Object
        },
        lineHeight: {
            type: Number
        }
    },
    computed: {
        fontStyle() {
            return this.fontObj
            ? Object.assign({}, this.fontObj, {
                fontSize: `${this.fontObj.fontSize}px`,
                color: `${this.fontObj.color}`,
                fontStyle: `${this.fontObj.fontStyle}`,
                fontFamily: this.fontObj.fontFamily,
                fontWeight: this.fontObj.fontWeight,
            })
            : {}
        },
        titleStyle() {
            return this.lineHeight
            ? Object.assign({}, {
                lineHeight: `${this.lineHeight}px`
            })
            : {
                lineHeight: '60px'
            }
        }
    }
}
</script>

<style lang="less">
.de-header-title-wrapper {
    width: 100%;
    height: 100%;
    .header-title1{
        width: 100%;
        height: 100%;
        background: url('~@/runtime-components/assets/images/title_1.png') no-repeat top center;
        background-size: contain;
        letter-spacing: 1px;
        text-align: center;
        line-height: 72px;
    }
    .header-title2 {
        margin-top: 20px;
        width: 100%;
        height: 80px;
        letter-spacing: 1px;
        text-align: center;
        line-height: 54px;
        background: url("~@/runtime-components/assets/images/title_2.png") no-repeat top center;
        background-size: contain;
    }
    .header-title3 {
        position: absolute;
        letter-spacing: 2px;
        width: 100%;
        height: 82px;
        background: url("~@/runtime-components/assets/images/title_3_bg.png") repeat-x top left;
        .layout-header-content {
            width: 100%;
            height: 82px;
            text-align: center;
            background: url("~@/runtime-components/assets/images/title_3.png") no-repeat top center;
            .header-title {
                padding-top: 20px;
                .arrow {
                    width: 66px;
                    height: 21px;
                    display: inline-block;
                    vertical-align: middle;
                    margin: 0 20px;
                }
                .arrow-left {
                    background: url("~@/runtime-components/assets/images/title_3_arrow1.png") no-repeat;
                    background-size: cover;
                }
                .arrow-right {
                    background: url("~@/runtime-components/assets/images/title_3_arrow2.png") no-repeat;
                    background-size: cover;
                }
            }
        }
    }
}
</style>